import React from "react";

/**
 * @deprecated [BubbleFillButton] is the new version of [BehavioralGoalsRating, BehavioralGoalsRatingLabelButtons]
 */

export function BehavioralGoalsRating(props) {
  const {
    containerClass,
    height = 15,
    isEditing,
    labelKey = "label",
    labelsEnabled = false,
    onClick,
    optionLabelMap,
    progress,
    ratingKey,
  } = props;

  let answerKey = ratingKey ? ratingKey : "answer";
  let containerClasses = containerClass
    ? `${containerClass} col-12 d-flex justify-content-start`
    : "col-12 d-flex justify-content-start";

  return (
    <div className={containerClasses}>
      {Object.keys(optionLabelMap).map((optionId) => {
        optionId = parseInt(optionId);
        let optionsClasses;

        // debugger
        if (progress[answerKey] !== null && progress[answerKey] === optionId) {
          optionsClasses = "RatingOption RatingOption-active w-100";
        } else {
          optionsClasses =
            "RatingOption w-100 " + (props.optionsClasses ? props.optionsClasses : "");
        }

        return (
          <div className="w-100" key={progress[labelKey] + optionId} style={{ margin: "0px 5px" }}>
            <button
              className={optionsClasses}
              disabled={!isEditing}
              id={`${optionId}`}
              onClick={onClick}
              style={{ height: height }}
              type="button"
              value={optionId}
            />
            {labelsEnabled && optionLabelMap[optionId] && (
              <label className="d-flex tw:justify-center">{optionLabelMap[optionId]}</label>
            )}
          </div>
        );
      })}
    </div>
  );
}
